// extracted by mini-css-extract-plugin
export default {"cardContainer":"SideEffects_cardContainer__XGdaR","card":"SideEffects_card__NvnVd","cardTitle":"SideEffects_cardTitle__2l3Vl"};